import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';
import sizeStandards from '../../../Style-guide/size-standards';

const ErrorPageWrapper = styled.main`
  padding: 20px;
  background: ${mainColors.main_color_gradient};
  box-sizing: border-box;
  min-height: 100vh;
  /* height: calc(100vh - 40px); */

  .error-title {
    text-align: center;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      font-size: 20px;
    }
  }

  .error-text {
    text-align: center;
    font-size: 22px;
    padding-top: 10% !important;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      font-size: 18px;
    }

    @media only screen and (max-width: 350px) {
      padding-top: 5% !important;
      font-size: 16px;
    }
  }

  .error-image-container {
    max-width: 900px;
  }

  .crash-image {
    width: 100%;
    height: 500px;

    @media only screen and (max-width: ${sizeStandards.screen.MD}px) {
      height: auto;
    }
  }

  .err-nav-home-btn {
    margin: 0 auto;
    display: block;
    background: linear-gradient(${mainColors.main_color}, transparent 60%);
    color: ${mainColors.text_color};
    padding: 4px 8px;
    border-radius: 8px;
    outline: none;
    border: 1px solid ${mainColors.main_color};
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
      background: linear-gradient(to top, ${mainColors.main_color}, transparent 60%);
    }
    &:active {
      background: ${mainColors.main_color_rgba(0.6)};
    }
  }
`;

export default ErrorPageWrapper;
